import { render } from "./DrugType.vue?vue&type=template&id=775b7af6"
import script from "./DrugType.vue?vue&type=script&lang=js"
export * from "./DrugType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__